import { useState } from "react"
import { Clock, ArrowRight, RotateCcw } from "lucide-react"
import { stepIcons, stepsDetail } from "./hepler"
import { useNavigate } from "react-router-dom"
import { PORTAL_ROUTES } from "utils/constants"
import AcceptanceHistoryModal from "./AcceptanceHistoryModal"
import { startCase } from 'lodash';
import { ReadyToBeginCard } from 'components/TreatmentPlan'
import { Button } from "components/Button"

const TxpProgressTracker = ({ treatmentPlan }) => {
  const navigate = useNavigate()
  const { step: currentStep, encoded_id, patient_signature_required } = treatmentPlan || {}

  const [isProgressModalOpen, setIsProgressModalOpen] = useState(false)

  let _stepsDetail = stepsDetail(patient_signature_required)
  let _stepIcons = stepIcons(patient_signature_required)

  let { title, text, description, btnTitle, sliderPercentage, progressTitle, step } = _stepsDetail[currentStep] || {}

  const navigateToReview = () => navigate(`${PORTAL_ROUTES.TREATMENT_PLANS}/${encoded_id}/review`)

  if (step === 'step_0' || (!patient_signature_required && currentStep == "payment_step"))
    return <ReadyToBeginCard onClick={navigateToReview} />

  return (
    <div className={`card w-full bg-gray-50 border border-base-200 shadow-sm rounded-2xl overflow-hidden hover:shadow-md transition-all duration-300`}>
      <div className="card-body p-6 flex flex-col xl:flex-row xl:items-start justify-between gap-6">
        <div className="flex-1 space-y-5">
          <div className="flex items-start gap-2">
            <div className="text-blue-800 mt-0.5 shrink-0">
              <Clock size={16} className="animate-pulse" />
            </div>

            <div>
              <h1 className="text-sm font-semibold text-secondary-900 leading-snug">{title}</h1>
              <p className="text-xs text-slate-500 mt-1.5">{text}</p>
            </div>
          </div>

          <div className="space-y-2">
            <div className="flex justify-between items-center text-xs font-medium">
              <span className="text-slate-900">{startCase(step)} of {_stepIcons.length}</span>
              <span className="text-slate-400">{progressTitle}</span>
            </div>

            <div className="w-full bg-slate-200/60 h-2 rounded-full overflow-hidden">
              <div className={`bg-black h-full rounded-full ${sliderPercentage || 'w-0'} transition-all duration-500 ease-out`} />
            </div>

            <div className="flex flex-row items-center justify-between gap-1.5 w-full flex-nowrap">
              {_stepIcons.map(({ icon, label, stepNumber }) => {
                const isActive = Number(step?.replace('step_', '')) >= stepNumber
                return (
                  <div key={label} className="flex items-center gap-1 shrink-0" title={label}>
                    <div className={`flex items-center justify-center w-6 h-6 rounded-full hover:scale-105 transition-transform duration-200 shrink-0 ${isActive ? 'bg-blue-600 text-white shadow-sm' : 'bg-slate-100 text-slate-400'}`}>
                      {icon}
                    </div>
                    <span className={`text-[10px] font-semibold whitespace-nowrap ${isActive ? 'text-slate-700' : 'text-slate-400'}`}>
                      {label}
                    </span>
                  </div>
                )
              })}
            </div>
          </div>

          <p className="text-xs text-slate-500 mt-1.5">{description}</p>
        </div>

        <div className="flex flex-row xl:flex-col gap-2.5 w-full xl:w-[140px] shrink-0 mt-1">
          {btnTitle &&
            <Button
              title={btnTitle}
              className="flex-1 xl:w-full bg-[#2563EB] hover:bg-blue-700 text-white text-xs px-2 rounded-lg flex gap-2 shadow-md shadow-blue-500/10 hover:shadow-lg hover:shadow-blue-500/20 active:scale-[0.98]"
              icon={<ArrowRight size={15} strokeWidth={2.5} />}
              variant="secondary"
              onClick={navigateToReview}
            />
          }

          <Button
            title={"View Progress"}
            className="flex-1 xl:w-full bg-white hover:bg-slate-50 text-slate-900 border border-slate-200 text-xs px-2 rounded-lg flex gap-2 shadow-sm active:scale-[0.98]"
            icon={<RotateCcw size={15} strokeWidth={2.5} />}
            variant="secondary"
            onClick={() => setIsProgressModalOpen(true)}
          />
        </div>

        <AcceptanceHistoryModal
          isOpen={isProgressModalOpen}
          onClose={() => setIsProgressModalOpen(false)}
          treatmentPlan={treatmentPlan}
        />
      </div>
    </div>
  )
}

export default TxpProgressTracker
